import React from "react";
import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

const Analytics = () => {
  const audits = useSelector((state) => state.audits);
  const completedAudits = audits.filter((audit) => audit.status === "Completed").length;

  const data = [
    { name: "Completed", value: completedAudits },
    { name: "Pending", value: audits.length - completedAudits },
  ];

  return (
    <div className="analytics">
      <h2>Audit Analytics</h2>
      <BarChart width={500} height={300} data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="value" fill="#8884d8" />
      </BarChart>
    </div>
  );
};

export default Analytics;
